import { SettingsPage } from 'Features/Projects/Scenarios/EditSettings/SettingsPage'

import { useSettingsContext } from 'Features/Projects/Scenarios/EditSettings/EditSettings.types'

import { NetworkCapacitiesTable } from './Capacities.Table'
import { useNetworkCapacities } from './Capacities.data'

export const NetworkCapacitiesView = () => {
  const { state } = useSettingsContext()
  const { projectId, scenarioId } = state

  const { data: networkCapacitiesData, isLoading } = useNetworkCapacities({
    projectId,
    scenarioId,
  })

  return (
    <SettingsPage title="Network capacities">
      <NetworkCapacitiesTable
        data={networkCapacitiesData ?? []}
        isLoading={isLoading}
      />
    </SettingsPage>
  )
}
